// extracted by mini-css-extract-plugin
module.exports = {"avatar":"SquadCatchUpItemSkeleton_avatar__1whwA","skeleton":"SquadCatchUpItemSkeleton_skeleton__3ONgh"};